import { createSlice } from "@reduxjs/toolkit";

const initialPersonAssignmentState = {
  listLoading: false,
  actionsLoading: false,
  //userGroups: [],
  personIds: [],
  filters: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const personAssignmentSlice = createSlice({
  name: "personAssignment",
  initialState: initialPersonAssignmentState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.noticeGroups = action.payload.entities;
      state.authorities =  action.payload.authorities;
    },
    // getNoticeGroups
    noticeGroupsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.noticeGroups = action.payload.entities;
    },
    // getPeople
    peopleFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities =  authorities;
    },
    // getFilters
    filtersFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.filters = action.payload.entities;
    },
    //getPersonIds
    personIdsFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.personIds = action.payload.ids;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanList
    listCleaned: (state) => {
      state.authorities = undefined;
      state.noticeGroups = [];
    },
    // cleanPersonIds
    personIdsCleaned: (state) => {
      state.personIds = [];
    },
    // cleanPeople
    peopleCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    }
  }
});